var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialIconThemeGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20924 1.06075C7.93424 0.97975 8.36324 0.97975 9.14224 1.06075C10.5212 1.26485 11.7995 1.90224 12.7922 2.88075C12.1214 3.51489 11.4593 4.15828 10.8062 4.81075C9.55558 3.75075 8.15958 3.50608 6.61824 4.07675C5.48758 4.59675 4.70024 5.43942 4.25624 6.60475C3.53068 6.06458 2.81457 5.51183 2.10824 4.94675C2.05915 4.92091 2.00309 4.91145 1.94824 4.91975C3.07024 2.75642 4.82358 1.46975 7.20824 1.05975",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94625 4.9192C2.00292 4.91054 2.05659 4.91954 2.10725 4.9462C2.81358 5.51128 3.52969 6.06403 4.25525 6.6042C4.14108 7.05826 4.0691 7.5219 4.04025 7.9892C4.06492 8.4412 4.13659 8.88487 4.25525 9.3202L2.00025 11.1152C1.01825 9.0632 1.00025 6.99787 1.94625 4.9192Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6851 13.2907C11.9829 12.6715 11.2479 12.0907 10.4831 11.5507C11.2497 11.0094 11.7151 10.2667 11.8791 9.32272H8.12207V6.71372C10.2887 6.69572 12.4544 6.71405 14.6191 6.76872C15.0297 8.99872 14.5554 11.0094 13.1961 12.8007C13.0344 12.9725 12.8632 13.1361 12.6851 13.2907Z",
    fill: "#448AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.255 9.32227C5.075 11.3603 6.57833 12.3116 8.765 12.1763C9.37883 12.1052 9.96735 11.8908 10.483 11.5503C11.2483 12.0916 11.9823 12.6716 12.685 13.2903C11.5716 14.2907 10.1521 14.8843 8.658 14.9743C8.31854 15.0014 7.97746 15.0014 7.638 14.9743C5.09267 14.6743 3.21333 13.3883 2 11.1163L4.255 9.32227Z",
    fill: "#43A047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialIconThemeGoogle);
export default __webpack_public_path__ + "static/media/material-icon-theme_google.b7cfcef5b266b984a273d0edd88f3a7d.svg";
export { ForwardRef as ReactComponent };